module.exports = __webpack_public_path__ + "img/portifolio_energystorage.f1d4e366.jpg";